export default __webpack_public_path__ + "static/media/clockIcon.29354de5.svg";